import React, { useState, useEffect } from 'react';
import ym from 'react-yandex-metrika';
import ReactGA from 'react-ga';
import Modal from 'react-modal';
import ReactHtmlParser from 'react-html-parser';
import WithDeviceType from '../../HOCs/WithDeviceType';
import { fb, inst, vk } from '../../../constants';
import MainModal from '../MainModal';
import './index.scss';

Modal.setAppElement('#root');

const HeaderSection = ({ desktop, api }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    api.sendInfo('mainPage').then((result) => setData(result));
  }, []);

  const [modalIsOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
    ym('reachGoal', 'obsudit-proekt');
    ReactGA.event({
      category: 'appayer_sur_le_bouton',
      action: 'distuter_du_projet',
      label: 'distuter_du_projet_premier_bloc'
    });
  };
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <section className="section header">
      <MainModal modalIsOpen={modalIsOpen} closeModal={closeModal} desktop={desktop} />

      <div className="header__blur">
        <canvas id="header__blur" />
      </div>
      <div className="wrapper wrapper_header">
        <div className="header__info">
          <h1 className="header__promoTitle">{ReactHtmlParser(data?.title)}</h1>
          <p className="header__desc">{ReactHtmlParser(data?.subtitle)}</p>
          <button className="header__button" onClick={openModal}>
            Обсудить проект
          </button>
        </div>
        <div className="header__nav-soc">
          <a
            href={vk}
            onClick={() => ym('reachGoal', 'vkontakte')}
            target="_blank"
            rel="noreferrer noopener"
            className="header__nav-soc-link"
            data-aos-delay="700"
            data-aos="fade-in"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7265 0C7.04108 0 0 7.16353 0 16C0 24.8365 7.04108 32 15.7265 32C24.4119 32 31.453 24.8365 31.453 16C31.453 7.16353 24.4119 0 15.7265 0ZM22.5462 18.1149C22.67 18.2706 22.9643 18.574 23.43 19.0256H23.4408L23.4517 19.0363L23.4625 19.0477L23.4845 19.0698C24.5101 20.0393 25.2047 20.8572 25.5686 21.5234C25.5906 21.56 25.6142 21.6067 25.6398 21.6622C25.6649 21.7177 25.6905 21.8157 25.716 21.9562C25.7412 22.0973 25.7393 22.2226 25.7105 22.3335C25.6815 22.4442 25.5906 22.5467 25.4379 22.6389C25.2851 22.7317 25.0705 22.7777 24.794 22.7777L22.0006 22.8225C21.8261 22.8595 21.6223 22.841 21.3895 22.767C21.1564 22.6927 20.9676 22.6113 20.8222 22.5227L20.6037 22.389C20.3853 22.2336 20.1308 21.9968 19.8399 21.6788C19.5487 21.3605 19.2997 21.0737 19.0924 20.8183C18.8851 20.5629 18.6631 20.3488 18.4265 20.1742C18.1898 20.0003 17.9844 19.9429 17.81 20.0023C17.7883 20.0101 17.759 20.023 17.7226 20.0412C17.6859 20.0597 17.6244 20.1129 17.537 20.2021C17.4496 20.291 17.3715 20.4004 17.3023 20.5295C17.2331 20.6593 17.1712 20.8517 17.1167 21.1071C17.0621 21.3621 17.0382 21.6493 17.0459 21.9676C17.0459 22.0782 17.0328 22.1804 17.0076 22.2729C16.9821 22.3653 16.9546 22.4338 16.9256 22.4779L16.8819 22.5334C16.7509 22.6746 16.5582 22.7557 16.3037 22.7777H15.0488C14.5321 22.8076 14.0011 22.7466 13.4558 22.5947C12.9104 22.4426 12.4318 22.2469 12.021 22.0062C11.6096 21.7661 11.2352 21.5217 10.8971 21.2738C10.5587 21.0256 10.3023 20.8131 10.1279 20.6356L9.85521 20.3689C9.7825 20.2953 9.68236 20.184 9.55511 20.0357C9.42786 19.8877 9.16794 19.5513 8.77503 19.0256C8.38213 18.5 7.99656 17.9416 7.61832 17.3491C7.24008 16.757 6.79455 15.976 6.28141 15.0065C5.76859 14.0373 5.29404 13.0308 4.85744 11.987C4.81375 11.8689 4.79175 11.769 4.79175 11.6875C4.79175 11.6064 4.80259 11.547 4.82459 11.5097L4.86829 11.4432C4.97736 11.3024 5.18465 11.232 5.49018 11.232L8.48004 11.2099C8.56742 11.2249 8.65098 11.2489 8.73102 11.2823C8.81107 11.3154 8.86943 11.3469 8.90579 11.3764L8.96033 11.4098C9.07673 11.4916 9.1638 11.6097 9.22216 11.7651C9.36759 12.1356 9.53502 12.5185 9.72414 12.9143C9.91325 13.3102 10.0625 13.6119 10.1716 13.8189L10.346 14.1411C10.5568 14.585 10.7606 14.9701 10.9571 15.2956C11.1538 15.6213 11.3299 15.8751 11.4865 16.0561C11.6427 16.2375 11.7936 16.3803 11.9393 16.4835C12.0848 16.5873 12.2085 16.6392 12.3106 16.6392C12.4123 16.6392 12.5105 16.6207 12.6052 16.5837C12.6196 16.5762 12.6378 16.5578 12.6598 16.5282C12.6818 16.4987 12.7252 16.4173 12.7909 16.2836C12.8562 16.1506 12.9053 15.9766 12.9382 15.7618C12.971 15.5477 13.0055 15.2479 13.0418 14.8631C13.0782 14.4779 13.0782 14.0156 13.0418 13.4753C13.0272 13.1791 12.9943 12.9092 12.9436 12.6648C12.8926 12.4208 12.8416 12.2505 12.7909 12.1541L12.7252 12.0211C12.5434 11.7696 12.2343 11.6103 11.7977 11.5435C11.703 11.5292 11.7212 11.4403 11.8523 11.2774C11.976 11.1366 12.1141 11.026 12.2669 10.9442C12.6524 10.7521 13.5218 10.6632 14.875 10.6775C15.4714 10.6853 15.9625 10.733 16.3481 10.8219C16.4935 10.8592 16.6153 10.9088 16.7135 10.9718C16.8118 11.0344 16.8864 11.1236 16.9374 11.2378C16.9881 11.3527 17.0264 11.4711 17.0519 11.5931C17.0774 11.7154 17.0902 11.8842 17.0902 12.0983C17.0902 12.3131 17.0867 12.5169 17.0793 12.709C17.072 12.9014 17.0631 13.1626 17.0522 13.4916C17.0414 13.8209 17.0357 14.1265 17.0357 14.4075C17.0357 14.4893 17.0321 14.6444 17.0248 14.8738C17.0175 15.1035 17.0152 15.281 17.0194 15.4066C17.0229 15.5324 17.0357 15.6827 17.0573 15.8563C17.0793 16.0302 17.1211 16.1749 17.183 16.2891C17.2445 16.404 17.3265 16.4945 17.4286 16.561C17.4866 16.5762 17.5485 16.5908 17.6142 16.6058C17.6796 16.6204 17.774 16.5801 17.8977 16.4835C18.0211 16.3874 18.1595 16.2596 18.3123 16.1006C18.465 15.9419 18.6542 15.694 18.8796 15.3569C19.1048 15.0208 19.3523 14.6226 19.6214 14.1635C20.058 13.3939 20.4471 12.561 20.789 11.6655C20.818 11.5912 20.8544 11.5266 20.8981 11.4711C20.9418 11.4153 20.9816 11.3764 21.018 11.3543L21.0617 11.3209C21.076 11.3134 21.0942 11.3043 21.1162 11.2933C21.1382 11.2826 21.1854 11.2713 21.2581 11.2599C21.3308 11.2492 21.4036 11.2472 21.4766 11.2547L24.6192 11.232C24.9027 11.1953 25.1355 11.2044 25.3173 11.2596C25.4991 11.3151 25.612 11.3764 25.6557 11.4429L25.7214 11.5539C25.8885 12.0279 25.3432 13.1152 24.0847 14.8176C23.9099 15.0548 23.6733 15.3696 23.3754 15.7615C22.8081 16.5019 22.4809 16.9867 22.3941 17.2167C22.2697 17.5195 22.3208 17.8193 22.5462 18.1149Z"
                fill="#ffffff"
              />
            </svg>
          </a>
          <a
            href={fb}
            onClick={() => ym('reachGoal', 'facebook')}
            target="_blank"
            rel="noreferrer noopener"
            className="header__nav-soc-link"
            data-aos-delay="800"
            data-aos="fade-in"
          >
            <svg
              width="33"
              height="32"
              viewBox="0 0 33 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.4413 0C7.36113 0 0 7.16353 0 16C0 24.8365 7.36113 32 16.4413 32C25.5215 32 32.8827 24.8365 32.8827 16C32.8827 7.16353 25.5215 0 16.4413 0ZM21.2718 9.17099C20.4903 9.17099 19.7038 9.17099 18.9226 9.17099C18.4282 9.13984 17.918 9.50714 17.8277 9.98832C17.817 10.8212 17.8223 11.6538 17.8223 12.4867C18.9703 12.4919 20.1186 12.4867 21.2668 12.4919C21.1818 13.6969 21.0278 14.8971 20.8471 16.087C19.8318 16.0973 18.8166 16.087 17.8013 16.0921C17.7907 19.6457 17.8067 23.194 17.796 26.7479C16.2863 26.7531 14.7823 26.7427 13.2726 26.7531C13.2459 23.1995 13.2726 19.646 13.2566 16.0921C12.523 16.087 11.7842 16.0973 11.0507 16.087C11.056 14.892 11.0507 13.6973 11.0507 12.5075C11.7842 12.4971 12.523 12.5075 13.2566 12.5023C13.2779 11.3436 13.2352 10.1798 13.2779 9.02109C13.3576 8.09507 13.7137 7.16937 14.4208 6.5331C15.2767 5.74173 16.4883 5.47274 17.6366 5.4416C18.8486 5.43121 20.0606 5.4364 21.2722 5.4364C21.2772 6.683 21.2772 7.9244 21.2718 9.17099Z"
                fill="#ffffff"
              />
            </svg>
          </a>
          <a
            href={inst}
            onClick={() => ym('reachGoal', 'instagram')}
            target="_blank"
            rel="noreferrer noopener"
            className="header__nav-soc-link"
            data-aos-delay="900"
            data-aos="fade-in"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  d="M19.8243 7.93945H11.5506C9.48018 7.93945 7.79565 9.65328 7.79565 11.7597V20.2545C7.79565 22.3609 9.48018 24.0748 11.5506 24.0748H19.8243C21.8947 24.0748 23.5792 22.3609 23.5792 20.2545V11.7597C23.5792 9.65328 21.8947 7.93945 19.8243 7.93945ZM15.7032 21.0936C12.8968 21.0936 10.6136 18.7954 10.6136 15.9706C10.6136 13.1458 12.8971 10.8476 15.7032 10.8476C18.5094 10.8476 20.7928 13.1458 20.7928 15.9706C20.7928 18.7954 18.5097 21.0936 15.7032 21.0936ZM20.8834 11.8564C20.222 11.8564 19.6859 11.311 19.6859 10.638C19.6859 9.96509 20.222 9.41966 20.8834 9.41966C21.5449 9.41966 22.081 9.96509 22.081 10.638C22.081 11.311 21.5449 11.8564 20.8834 11.8564Z"
                  fill="#ffffff"
                />
                <path
                  d="M15.7265 0C7.04108 0 0 7.16353 0 16C0 24.8365 7.04108 32 15.7265 32C24.4119 32 31.453 24.8365 31.453 16C31.453 7.16353 24.4119 0 15.7265 0ZM25.4366 20.2547C25.4366 23.4033 22.9187 25.9646 19.8243 25.9646H11.5506C8.4558 25.9646 5.93826 23.403 5.93826 20.2547V11.7599C5.93826 8.61129 8.45612 6.04997 11.5506 6.04997H19.8243C22.9191 6.04997 25.4366 8.61162 25.4366 11.7599V20.2547Z"
                  fill="#ffffff"
                />
                <path
                  d="M15.7032 12.7339C13.9188 12.7339 12.4674 14.1859 12.4674 15.9707C12.4674 17.7556 13.9188 19.2076 15.7032 19.2076C17.4875 19.2076 18.9389 17.7556 18.9389 15.9707C18.9389 14.1859 17.4875 12.7339 15.7032 12.7339Z"
                  fill="#ffffff"
                />
              </g>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default WithDeviceType(HeaderSection);
